import useSWR from 'swr';
import { fetchFarmerDashboardData, fetchSpecialistDashboardData } from './dashboardService';
import { useDashboardStore } from './dashboardStore';

export function useFetchFarmerDashboard() {
	const { setFarmerData } = useDashboardStore();

	const { data, error, isValidating, mutate } = useSWR(
		'analytics/farmer',
		fetchFarmerDashboardData,
		{
			onSuccess: (data) => {
				setFarmerData(data);
			},
			revalidateOnFocus: false,
			shouldRetryOnError: false,
			revalidateIfStale: false,
			dedupingInterval: 60000, // 1 minute
		}
	);

	const refresh = () => mutate();

	return {
		farmerData: data || null,
		isLoading: isValidating,
		error,
		refresh,
	};
}

export function useFetchSpecialistDashboard() {
	const { setSpecialistData } = useDashboardStore();

	const { data, error, isValidating, mutate } = useSWR(
		'analytics/specialist',
		fetchSpecialistDashboardData,
		{
			onSuccess: (data) => {
				setSpecialistData(data);
			},
			revalidateOnFocus: false,
			shouldRetryOnError: false,
			revalidateIfStale: false,
			dedupingInterval: 60000, // 1 minute
		}
	);

	const refresh = () => mutate();

	return {
		specialistData: data || null,
		isLoading: isValidating,
		error,
		refresh,
	};
}
